<template>
  <div>
    <div class="d-flex align-items-center mb-2 justify-content-between">
      <div class="w-50 dropdown-style d-flex">
        <v-select
          id="inf_id"
          :options="fenomenList"
          v-model="getInfId"
          :reduce="val => val.value"
          class="w-auto fixed-width btn text-primary p-0 dropdown-toggle btn-outline-primary"
          placeholder="Tüm Fenomenler"
          :clearable="false"
           v-if="!isFenomen"
        />
        <!-- Temizleme butonu -->
        <button 
          @click="getInfId=null" 
          class="btn btn-outline-danger ml-2 w-auto"
          v-if="getInfId && !isFenomen"
        >
          <i class="fa fa-times"></i>
          Tüm Fenomenler
        </button>
        <!-- Temizleme butonu -->
        <button 
          @click="updateMonth(null)" 
          class="btn btn-outline-danger ml-2 w-auto"
          v-if="selectedMonth"
        >
          <i class="fa fa-trash"></i>
          Filtre Sil
        </button>

      </div>
      <b-dropdown
        :text="nowYear.toString()"
        size="md"
        class="budget-dropdown ml-auto"
        variant="outline-primary"
      >
        <b-dropdown-item
          v-for="year in $globalYears()"
          :key="year"
          @click="selectYear(year)"
          :active="year==nowYear"
        >
          {{ year }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
    
    <b-row class="match-height">

      <!-- Sipariş Tutarları Grafiği -->
      <b-col md="6">
        <chartjs-bar-chart @update-data="updateMonth" :chartData="chartData" :loadChart="loadChart"/>
      </b-col>

      <!-- Sipariş Adetleri Grafiği -->
      <b-col md="6">
        <chartjs-horizontal-bar-chart @update-data="updateMonth" :chartData="chartDataHorizontal" :loadChart="loadChart"/>
      </b-col>
    </b-row>

    <!-- Fenomen Hakediş Tablosu -->
    <b-card
    no-body v-if="!getInfId">
      <b-card-title class="text-center py-2 mb-0">
        {{ getTitle }}
      </b-card-title>
      <b-spinner v-if="isLoading" class="mx-auto my-4" label="Yükleniyor..."></b-spinner>
      <b-table v-else
          :items="fenomenDataListOrders"
          :fields="fenomenTableColumn"
        >
        <template #cell(username)="data">
            <router-link :to="{name:'influencer-detail',params:{id:data.item.id}}" target="_blank">
              <feather-icon icon="InstagramIcon" size="22"  />
              {{ data.item.username ? data.item.username : 'Bilinmeyen' }}
            </router-link>
        </template>
        <template #head(vesting_count)="data">
          <div class="text-center">{{ data.field.label }}</div>
        </template>

        <template #head(vesting_payment)="data">
          <div class="text-right">{{ data.field.label }}</div>
        </template>

        <template #cell(vesting_count)="data">
            <div class="text-center"> {{ data.item.vesting_count }} </div>
        </template>
        
        <template #cell(vesting_payment)="data">
          <div class="text-right">{{ priceFormat(data.item.vesting_payment) }}</div>
        </template>
      </b-table>
    </b-card>
    
    <!-- İlgili Siparişler -->
    <order :tableColumns="tableColumns" v-if="getInfId" :params="params" @orders-fetched="handleOrdersFetched" :title="getTitle+ 'İlgili siparişler'"></order>
  </div>
</template>
  
  <script>
  import { BRow,BFormGroup,BSpinner, BCardTitle, BDropdown, BDropdownItem,BCardSubTitle, BCol, BCard, BLink, BTable } from 'bootstrap-vue'
  import order from '../Orders.vue';
  
  import ChartjsBarChart from './ChartjsBarChart.vue'
  import ChartjsHorizontalBarChart from './ChartjsHorizontalBarChart.vue'
  import chartjsData from '@/components/charts-components/chartjsData'

  import vSelect from 'vue-select'

  const now = new Date();

  export default {
    components: {
      BRow,
      BCol,
      BLink,
      BCard,
      BDropdown,
      BDropdownItem,
      BCardSubTitle,
      BFormGroup,
      BCardTitle,

      vSelect,
      BTable,
      BSpinner,

      order,
      ChartjsBarChart,
      ChartjsHorizontalBarChart
    },
    data() {
      return {
        chartjsData,
        nowYear:now.getFullYear(),
        orderList: [],
        orderListCopy:[],
        chartData: {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor:  '#28dac6',
              borderColor: 'transparent',
              barThickness: 15,
            },
          ],
        },
        chartDataCopy:{},
        chartDataHorizontal: {},
        loadChart: true,
        tableColumns : [
          { key: 'id', sortable: true },
          { key: 'link', label: 'Paylaşım Bilgisi', sortable: true },
          { key: 'created_date', label: 'Sipariş Tarihi', sortable: true },
          { key: 'transaction', label: 'Sipariş No', sortable: true },
          { key: 'amount', label: 'Toplam', sortable: true },
          { key: 'inf_payment_total', label: 'Ödenecek Tutar', sortable: true },
          { key: 'order_status', label: 'Sipariş Durumu', sortable: true },
          { key: 'payment_status', label: 'Ödeme Durumu', sortable: true },
          { key: 'show_details', label: 'DETAY'},
        ],
        fenomenTableColumn:[
          { key: 'id', label: 'ID'},
          { key: 'username', label: 'FENOMEN'},
          { key: 'label', label: 'Adı Soyadı' },
          { key: 'vesting_count', label: 'Hakediş Sipariş Adedi'},
          { key: 'vesting_payment', label: 'Hakediş Toplam Tutar'},
          { key: 'test', label: 'Bekleyen Hakediş Tutarı/Adedi'},
        ],
        selectedMonth:null,
        fenomenList:[],
        getInfId:parseInt(this.$route.params.id , 10),
        props:{},
        params:{
          year:now.getFullYear(),
          filter: {
            vesting_status: 1,
          }
        },
        isLoading:true
      }
    },
    methods: {
      handleOrdersFetched() {
        // Eğer hakediş ana ekranı ise özel sutünlar gelmesi yeterli.
        this.isLoading=true
        let params = this.params
        this.$http.get('/order/getVestingSummary',{params}).then((response)=>{
          this.fenomenList=response.data.data
          if(!this.selectedMonth){
            this.orderList = response.data.data;
            this.updateChartData();
          }
          setTimeout(() => {
            this.isLoading=false
          }, 250);
        })
        
      },
      updateMonth(elementIndex) {
        this.selectedMonth = elementIndex
        this.createParams()
      },
      selectYear(year){
        this.selectedMonth=null
        if(this.nowYear!=year){
          this.loadChart=false;
          this.nowYear=year;
          this.createParams();
        }
      },
      updateChartData() {
        this.chartData=JSON.parse(JSON.stringify(this.chartDataCopy));
        this.loadChart=false;
        
        const labels = this.diffDateMonth(this.nowYear);

        const orderList = [];
        this.fenomenList.forEach(item => {
          if (this.getInfId && item.id == this.getInfId && Array.isArray(item.orders)) {
            
            orderList.push(...item.orders);
          } else if (!this.getInfId && Array.isArray(item.orders)) {
            // getInfId yoksa tüm orders'ları ekle
            orderList.push(...item.orders);
          }
        });


        // Sipariş verilerini toplayın
        const dataAmount = labels.map((label) => {
          const monthOrders = orderList.filter((order) => this.$moment(order.created_date).format('MMMM') === label);
          return monthOrders.reduce((total, order) => total + order.vesting_total_amount, 0);
        });

        const dataCount = labels.map((label) => {
          const monthOrders = orderList.filter((order) => this.$moment(order.created_date).format('MMMM') === label);
          return monthOrders.reduce((total, order) => total + 1, 0);
        });

        // chartData'yı güncelleyiyorum...
        this.chartData.labels = [...labels];
        this.chartData.datasets[0].data = [...dataAmount]; // Burada döngüsel yapı olmamalı


        this.chartDataHorizontal = JSON.parse(JSON.stringify(this.chartData));
        this.chartDataHorizontal.labels = [...this.chartData.labels].reverse();
        this.chartDataHorizontal.datasets[0].data = [...dataCount].reverse(); // Burada döngüsel yapı olmamalı

        setTimeout(() => {
          this.loadChart=true 
        }, 500);
      },
      createParams(){
        let params = {
          year:this.nowYear,
          filter: {
            vesting_status: 1,
          },
        }
        if(this.selectedMonth){
          if (this.selectedMonth) {
            params.month = this.selectedMonth+1; // Ay bilgisini de ekliyoruz
          }
        }
        if (this.getInfId ) {
          params['infId'] = this.getInfId;
        }
        this.params=params;
        if(!this.getInfId){
          this.handleOrdersFetched();
        }
      }
    },
    computed: {
      getTitle(){
        let title=''
        const selectedUser = this.fenomenList.find(item => item.id === this.getInfId);
        title+=selectedUser ? selectedUser.label +' - ' : ''; // Öğe yoksa boş döner
        title+=this.selectedMonth ? ' '+this.chartData.labels[this.selectedMonth]+'/' : ''; // Öğe yoksa boş döner
        title+=this.nowYear + ' '
        return title
      },
      fenomenDataListOrders() {
        return this.fenomenList.filter(item => item.vesting_count > 0).sort((a, b) => b.vesting_count - a.vesting_count);
      }
    },
    watch: {
      getInfId(newValue) {
        this.selectedMonth=null
        if(!this.isFenomen){
          this.$router.push({ name: 'vesting', params: { id: newValue } });
        }
        this.createParams();
      },
    },
    created() {
      if(this.isFenomen){
        this.getInfId=this.userData.id
      }
      this.handleOrdersFetched();
      this.chartDataCopy=JSON.parse(JSON.stringify(this.chartData));
    },
  }
  </script>
  

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .fixed-width {
    min-width: 230px; /* İhtiyaca göre genişliği ayarlayın */
    width: 100%;
  }
  .dropdown-style{
    .vs__dropdown-toggle{
      border:none; 
    }
    .vs__selected{
      color: var(--indigo) !important;
    }
    .dropdown-toggle::after{
      right: 10px;
      left: inherit;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  </style>